import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import ReportDefinitions from '../../../../common/config/ReportDefinitions';
import Report from '../../../common/components/Report';
import {
  getColumns,
  getData,
  getGeneratedOnDateTime,
  getIsLoading,
} from '../redux/selectors/MixedTrayUsageSelectors';

export function MixedTrayUsageContainer(props) {
  return (
    <Report
      reportId={ReportDefinitions.MIXED_TRAY_USAGE_942.id}
      columns={props.columns}
      isLoading={props.isLoading}
      generatedOnDateTime={props.generatedDateTime}
      data={props.data}
    />
  );
}

function mapStateToProps(state) {
  return {
    data: getData(state),
    generatedDateTime: getGeneratedOnDateTime(state),
    isLoading: getIsLoading(state),
    columns: getColumns(state),
  };
}

MixedTrayUsageContainer.propTypes = {
  data: PropTypes.arrayOf(PropTypes.object),
  generatedDateTime: PropTypes.string,
  isLoading: PropTypes.bool,
  columns: PropTypes.arrayOf(PropTypes.object),
};

export default connect(mapStateToProps)(MixedTrayUsageContainer);
